"use client";

import { useIsDark } from "@/context/ThemeContext";
import { twMerge } from "tailwind-merge";

export default function ProjectsLayout({ children }) {
  const isdark = useIsDark();
  return (
    <div>
      {/* left top  */}
      <section className="hidden lg:block relative -translate-y-50 xl:translate-y-0">
        <div
          className={twMerge(
            "absolute top-[469px] left-[-31px] w-[313px] h-[272px] rounded-full rotate-126 blur-[100px]",
            isdark ? "bg-[#8593E8] opacity-40" : "bg-[#A1ADF5] opacity-60"
          )}
        />
        <div
          className={twMerge(
            "absolute top-[610px] left-[-244px] w-[315px] h-[275px] rounded-full  rotate-126 blur-[120px]",
            isdark ? "bg-[#5D6EF3] opacity-40" : "bg-[#2A40E7] opacity-40"
          )}
        />
        <div
          className={twMerge(
            "absolute top-[848px] left-[-260px] w-[300px] h-[262px] rounded-full rotate-126 blur-[100px]",
            isdark ? "bg-[#FC4FF6] opacity-20" : "bg-[#FF8DFB] opacity-60"
          )}
        />
      </section>

      {/* right middle */}
      <section className="hidden lg:block relative mobile2:-translate-y-40 xl:translate-y-0">
        <div
          className={twMerge(
            "absolute top-[1042px] right-[-135px] w-[313px] h-[272px] rounded-full rotate-120 blur-[100px]",
            isdark ? "bg-[#8593E8] opacity-40" : "bg-[#A1ADF5] opacity-40"
          )}
        />
        <div
          className={twMerge(
            "absolute top-[1092px] right-[-150px] w-[274px] h-[315px] rounded-full rotate-120 blur-[120px] bg-[#2A40E7] opacity-40"
          )}
        />
        <div
          className={twMerge(
            "absolute top-[1331px] right-[-54px] w-[300px] h-[262px] rounded-full rotate-120 blur-[100px] opacity-40",
            isdark ? "bg-[#DF27DF]" : "bg-[#FF8DFB]"
          )}
        />
      </section>

      {/* left bottom  */}
      <section className="hidden xl:block relative -translate-y-50 xl:translate-y-0">
        <div
          className={twMerge(
            "absolute top-[2750px] left-[-127px] w-[300px] h-[262px] rounded-full rotate-120 blur-[100px] opacity-40",
            isdark ? "bg-[#DF27DF]" : "bg-[#FF8DFB]"
          )}
        />
        <div
          className={twMerge(
            "absolute top-[2950px] left-[-168px] w-[274px] h-[315px] rounded-full rotate-120 blur-[120px] bg-[#2A40E7] opacity-40"
          )}
        />
      </section>

      <div className="">{children}</div>
    </div>
  );
}
